import React, { useState } from 'react';
import ReactGA from 'react-ga4';
import Navigation from './layout/Navigation';
import Main from './layout/Main';
// import Footer from './layout/Footer';

const App = () => {
	const [headerHeight, setHeaderHeight] = useState(60);

	ReactGA.initialize([
		{
			trackingId: 'G-FPW65XK3DC',
			gaOptions: {
				name: 'Without Envato',
			},
		},
		{
			trackingId: 'G-ZVQ8S34JK5',
			gaOptions: { name: 'With Envato' },
		},
	]);
	ReactGA.send('pageview');

	return (
		<div className='container-fluid p-0 TEST'>
			<Navigation setHeaderHeight={setHeaderHeight} />
			<Main headerHeight={headerHeight} />
			{/* <Footer /> */}
		</div>
	);
};

export default App;
